import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { useThemeContext } from '../../contexts/ThemeContext';
import { colors } from '../../styles/fontStyles';

const HeaderBanner = ({ imageSrc, title, subtitle, description, linkText, linkUri }) => {
  const navigate = useNavigate();
  const { theme } = useThemeContext();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isMobile ? 'column-reverse' : 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0',
        background: theme.custom.components.headerBanner.background,
        borderRadius: '8px',
        marginTop: '0px',
        marginBottom: '16px',
      }}
    >
      {/* Image Section */}
      <Box
        component="img"
        src={imageSrc}
        alt="Header"
        sx={{
          width: isMobile ? '100%' : '40%',
          borderRadius: '8px',
          marginTop: isMobile ? '16px' : '0',
        }}
      />

      {/* Text Section */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          width: isMobile ? '100%' : '60%',
          paddingLeft: isMobile ? '0' : '32px',
          textAlign: isMobile ? 'center' : 'left',
        }}
      >
        <Typography
          variant="h2"
          sx={{
            color: theme.custom.components.headerBanner.title.color,
            fontWeight: 400,
            fontStyle: 'normal',
            fontSize: '57px',
            lineHeight: '64px',
            marginBottom: '8px',
            letterSpacing: '-0.25px',
          }}
        >
          {title}
        </Typography>

        <Typography
          variant="h4"
          sx={{
            color: theme.custom.components.headerBanner.subtitle.color,
            fontWeight: 400,
            fontSize: '22px',
            fontStyle: 'normal',
            lineHeight: '28px',
            marginBottom: '8px',
          }}
        >
          {subtitle}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: theme.custom.components.headerBanner.description.color,
            fontWeight: 400,
            fontSize: '14px',
            fontStyle: 'normal',
            lineHeight: '20px',
            letterSpacing: '-0.25px',
          }}
        >
          {description}
        </Typography>

        {linkText && (
          <Box
            component="a"
            onClick={() => navigate(linkUri)}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              textDecoration: 'none',
              color: colors.primaryBlue,
              '&:hover': {
                textDecoration: 'underline',
              },
              cursor: 'pointer',
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '20px',
                color: colors.primaryBlue,
              }}
            >
              {linkText}
            </Typography>
            <img src="/icons/arrow-narrow-right.svg" alt="information" style={{ marginLeft: '4px' }} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default HeaderBanner;
